import $ from 'jquery';
import util from 'util/Util.js';
import BasePropertyView from 'BasePropertyView.js';
import formatTemplate from 'properties/main/calendar_value.ejs';
import dateUtil from 'shared/DateUtil.js';
import constants from 'Constants';
import moment from 'moment';

class MainCalendarValueView extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = formatTemplate;
        this.tagName = 'div';
        this.id = opts.el;
        this.config = opts.config || {};

        this.events = {
            'change input[type=radio]' : 'setDateValue',
            'change #dateValueSpecific' : 'setSpecificDate',
            'change input[type=text]' : 'updateAttributes',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus'
        };        
        if(!this.model.get('dateValue')) {
            this.model.set('dateValue','',{silent:true});
        }
        if(!this.model.get('dateValueObj')) {
            this.model.set('dateValueObj',null,{silent:true});
        }
        if (!this.model.get('minYear')) {
            this.model.set('minYear', '1900', {silent:true});
        }
        if (!this.model.get('maxYear')) {
            this.model.set('maxYear', '2100', {silent:true});
        }
        if (util.isTrue( this.model.get('showNow')) ) {
            this.model.set('dateValueType', 'Now', {silent: true});
            this.model.set('dateValue', this.getFormattedDate(new Date()), {silent: true});
        } else {
            this.model.set('dateValueType', 'Specific', {silent: true});
        }
        if (this.model.get('specific')) {
            this.model.set('dateValue', this.getFormattedDate(this.model.get('specific')), {silent:true});
        } else {
            // HTML Player requires non-empty value
            this.model.set('specific', dateUtil.convertDateToISOString(new Date()), {silent: true});
        }

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    getServerFormattedDate(date) {
        const d = moment(date);

        var month = d.month() + 1;
        var day = d.date();

        if(month <= 9) {
            month = '0' + month;
        }
        if(day <=9) {
            day = '0' + day;
        }

        return d.year() + '-' + month + '-' + day + ' 00:00:00';

    }

    getFormattedDate(date) {
        const d = moment(date);

        var month = d.month() + 1;
        var day = d.date();

        if(month <= 9) {
            month = '0' + month;
        }
        if(day <=9) {
            day = '0' + day;
        }
            return month + '/' + day + '/' +  d.year();
    }

    resetSpecific(){
        $('#dateValueSpecific').attr('disabled', true);
        $('#dateValueSpecific').val('');
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        let propVal  = ev.currentTarget.value;

        if(propName === 'maxYear'){
            if(Number(propVal) > 2100 ){
                propVal = '2100';
            }else if(Number(propVal) < Number(this.model.get('minYear'))){
                propVal = this.model.get('minYear')
            }
        }else if(propName === 'minYear'){
            if(Number(propVal) < 1900 ){
                propVal = '1900';
            }else if(Number(propVal) > Number(this.model.get('maxYear'))){
                propVal = this.model.get('maxYear')
            }
        }else if(propName === 'dateValueSpecific'){
            var date = moment(propVal,'MM/DD/YYYY');
            if(date.year() > Number(this.model.get('maxYear')) ){
               date = date.year(Number(this.model.get('maxYear')));
            }else if(date.year() < Number(this.model.get('minYear'))){
               date = date.year(Number(this.model.get('minYear')));
            }
            this.model.set('dateValue', date.format('MM/DD/YYYY'), {silent:true}); 
            this.model.set('specific', this.getServerFormattedDate(date), {silent:true}  );
            return;
        }
        this.model.set( propName, propVal );
    }

    setSpecificDate(ev) {
        ev.preventDefault();
        const propVal  = ev.currentTarget.value;
        const newSpecificDisplay = dateUtil.getFormattedDate(propVal, 'MM/DD/YYYY');
        if(!newSpecificDisplay){
           ev.currentTarget.value = this.model.get('dateValue');
           return;
        }
        
        this.model.set('dateValue', newSpecificDisplay, {silent:true});
        this.model.set('specific', dateUtil.convertDateToISOString(newSpecificDisplay));
            
    }

    setDateValue(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;
        this.model.set(propName, propVal, {silent:true});

        if(propVal ==='Now') {
            var date = new Date();
            this.model.set('specific', this.getServerFormattedDate(date), {silent:true} );
            this.model.set('dateValue', this.getFormattedDate(date), {silent:true});
            this.model.set('showNow', 'true');
        }else if(propVal === 'Specific') {
            this.model.set('showNow', 'false');
            $("#dateValueSpecific").datepicker('enable');
            $('#dateValueSpecific ~ img').css('opacity',constants.CSS_CALENDAR_ENABLE);

        }else{
            $('#dateValueSpecific ~ img').css( 'opacity', constants.CSS_CALENDAR_DISABLE);
        }
    }

    _injectDatePicker(){
        const $dp = $('#dateValueSpecific');        
        var self = this;

        $dp.datepicker({
            showOn: "button",
            buttonImage: require('common/icons/calendar.png'),
            buttonImageOnly: true,
            buttonText: "Select date",
            changeYear: true,
            changeMonth: true,
            gotoCurrent: true,
            defaultDate: new Date(),
            disabled: false,
            yearRange: this.model.get('minYear')+':' +this.model.get('maxYear'),
            beforeShow: function( opts ){
                setTimeout(function(){
                    $('.ui-datepicker').css('z-index', constants.Z_INDEX_CALENDAR);
                }, 0);
            },
            onSelect: function ( opts ) {
                self.model.set('specific', self.getServerFormattedDate(opts),{silent:true});
                self.model.set('dateValue', self.getFormattedDate(opts));
            }
        });
    }


    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }


        $(`:radio[value='${this.model.get('dateValueType')}']`).attr('checked', true);


        // Rendering jQueryUI Datepicker inside a respective tag after the UI and model was loaded
        this._injectDatePicker();

        if(this.model.get('dateValueType') !== 'Specific') {
            $("#dateValueSpecific").datepicker('disable');
            $('#dateValueSpecific ~ img').css({ opacity: constants.CSS_CALENDAR_DISABLE, cursor: "default" });
        }else{
            $('#dateValueSpecific ~ img').css('opacity',constants.CSS_CALENDAR_ENABLE)
        }

        if (this.config.showTitle) {
            this.$el.find('.propTitle').removeClass('hide');
        }

        this.delegateEvents();
        return this;
    }

}

export default MainCalendarValueView;
